import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Form, Row, TimePicker } from "antd";

export default function RenderTimePicker(props) {
	const {
		namePath = [],
		required = false,
		question = null,
		description = null,
		add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	// If add_another is enabled, render for each input set
	if (add_another) {
		return (
			<>
				{inputs.map((input, idx) => (
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}
						key={`input_set_${input.id}`}
					>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<div
									className="quill-output question"
									dangerouslySetInnerHTML={{
										__html: question,
									}}
								/>
								{description && (
									<div className="description">{description}</div>
								)}
							</Col>
						</Row>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<Form.Item
									name={`${newNamePath}_set_${idx}`}
									rules={[
										{
											required: required ? true : false,
											message: "This field is required!",
										},
									]}
								>
									<TimePicker style={{ width: "100%" }} />
								</Form.Item>
							</Col>
						</Row>
					</Col>
				))}

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Button
						type="link"
						className="w-auto h-auto p-0"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={handleAddAnother}
					>
						Add Another
					</Button>
				</Col>
			</>
		);
	}

	return (
		<Row>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div
					className="quill-output question"
					dangerouslySetInnerHTML={{
						__html: question,
					}}
				/>
				{description && <div className="description">{description}</div>}
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Form.Item
					name={newNamePath}
					rules={[
						{
							required: required ? true : false,
							message: "This field is required!",
						},
					]}
				>
					<TimePicker style={{ width: "100%" }} />
				</Form.Item>
			</Col>
		</Row>
	);
}
